// ============================================================================
// apps/devopsRenderer.tsx — ПРИЛОЖЕНИЕ «Разработка» (appKind='devops').
// Доступ: администратор ИЛИ роли поставки hydra.devops («Разработка —
// управление» / «Разработка — просмотр»). Без ролей приложение скрыто в
// доке/«Пуске» (useVisibleApps) и при прямом открытии показывает явный отказ.
// Серверные гейты DevopsService — SSoT доступа.
// ============================================================================

import { ShieldOff } from 'lucide-react';
import { DevopsPage } from '@/pages/DevopsPage';
import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { useSecurityAccess } from '@/lib/securityRoles';
import { canViewDevops } from '@/lib/devopsRoles';

export const DEVOPS_APP_CODE = 'devops';

function DevopsApp() {
  const access = useSecurityAccess();
  if (!canViewDevops(access)) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <div className="max-w-md rounded-lg border bg-card p-5 text-center">
          <ShieldOff className="mx-auto mb-2 h-6 w-6 text-muted-foreground" />
          <div className="text-sm font-medium">Панель разработки недоступна</div>
          <div className="mt-1 text-xs text-muted-foreground">
            Нужна роль «Разработка — просмотр» или «Разработка — управление».
            Запуск задач доступен роли «Разработка — управление».
          </div>
        </div>
      </div>
    );
  }
  return <DevopsPage />;
}

export const DEVOPS_APP_MANIFEST: AppManifest = {
  code: DEVOPS_APP_CODE,
  name: 'devops',
  synonym: 'Разработка',
  appKind: 'devops',
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['events', 'notify', 'data:read'],
};

export function registerDevopsApp(): void {
  registerAppRenderer({
    appKind: 'devops',
    code: DEVOPS_APP_CODE,
    title: 'Разработка',
    Component: DevopsApp,
    manifest: DEVOPS_APP_MANIFEST,
  });
}
